var map = {
	"./c0.png": "XNRS",
	"./c1.png": "WXPv",
	"./c2.png": "+ZI2",
	"./c3.png": "Yq7q",
	"./czxh.png": "Qdkh"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Mucl";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slwh ^\.\/c.*\.png$
// module id = Mucl
// module chunks = 0